import type { CharacterConfig, MissionPhase } from '../../types/content';

export const SAVE_SCHEMA_VERSION = 4;
export const CONTENT_VERSION = 3;

export interface SavedCheckpoint {
  levelId: string;
  id: string;
  spawnId: string;
  missionPhase: MissionPhase;
  elapsedMs: number;
  tokens: number;
}

export interface PlayerSettings {
  music: boolean;
  sound: boolean;
  reducedMotion: boolean;
  leftHanded: boolean;
  jumpButtonScale: number;
  actionButtonScale: number;
}

export interface GuestPayload {
  selectedCharacter: CharacterConfig['id'];
  unlockedCharacters: CharacterConfig['id'][];
  checkpoint: SavedCheckpoint | null;
  completedLevels: string[];
  highScores: Record<string, number>;
  achievements: string[];
  settings: PlayerSettings;
  disclaimerAccepted: boolean;
  signInDismissedUntil: number;
}

export interface GuestSaveEnvelope {
  schemaVersion: number;
  contentVersion: number;
  revision: number;
  updatedAt: number;
  payload: GuestPayload;
  checksum: string;
}

export function defaultPayload(): GuestPayload {
  return {
    selectedCharacter: 'rebel',
    unlockedCharacters: ['rebel', 'jugaadu', 'gen-z'],
    checkpoint: null,
    completedLevels: [],
    highScores: {},
    achievements: [],
    settings: { music: true, sound: true, reducedMotion: false, leftHanded: true, jumpButtonScale: 1, actionButtonScale: 1 },
    disclaimerAccepted: false,
    signInDismissedUntil: 0,
  };
}
